export const pillTokens = {
  pill: {
    root: {
      borderRadius: '48px',
      padding: '6px 12px 6px 10px',
      gap: '3px',
      textColor: '{surface.1000}'
    },
    draft: {
      background: '{surface.100}',
      borderColor: '{surface.300}',
      color: '{surface.500}'
    },
    info: {
      background: '{info.background}',
      borderColor: '{primary.400}',
      color: '{surface.1000}'
    },
    done: {
      background: '{success.background}',
      borderColor: '{success.color}',
      color: '{success.color}'
    },
    attention: {
      background: '{warn.background}',
      borderColor: '{warn.color}',
      color: '{warn.color}'
    },
    error: {
      background: '{danger.background}',
      borderColor: '{danger.color}',
      color: '{danger.color}'
    }
  }
};

export type PillTokens = typeof pillTokens;
